module.exports = "/assets/data/d182726aaf3dc56a5b757c00764ee632-G40.data.json";